import { Trans, useTranslation } from 'next-i18next';
import { overlay } from 'overlay-kit';
import { logger } from '@zep/core-logger';
import { CreateContentBannerItem } from '@/shared/components';
import { CreateQuizBannerModal } from './CreateQuizBannerModal';

/**
 * 자료실(/public) 퀴즈 목록 최상단의 "만들기" 배너.
 *
 * 표현은 공용 CreateContentBannerItem 이 담당하고, 여기서는 자료실 전용
 * 문구·트래킹(public_create_click)·퀴즈/보드 선택 모달만 붙인다.
 * (학급 연결 모달은 탭으로 콘텐츠 타입이 이미 정해져 있어 선택 모달을 쓰지 않는다)
 */
export const CreateQuizBannerItem = () => {
  const {
    t
  } = useTranslation(['common']);
  const handleClick = () => {
    logger.track('public_create_click');
    overlay.open(({
      unmount
    }) => <CreateQuizBannerModal onClose={unmount} />);
  };
  return <CreateContentBannerItem title={<Trans t={t} i18nKey="common:createBanner.title" components={{
    Strong: <strong className="text-primary" />
  }} />} mobileTitle={<Trans t={t} i18nKey="common:createBanner.titleMobile" components={{
    Strong: <strong className="text-primary" />
  }} />} description={t('common:createBanner.description')} onClick={handleClick} data-sentry-element="CreateContentBannerItem" data-sentry-component="CreateQuizBannerItem" data-sentry-source-file="CreateQuizBannerItem.tsx" />;
};